import { publicUrlFor } from "../../../../globals/constants";
import { NavLink } from "react-router-dom";
import ItodoImage from "../../../elements/itodo-img";

function SectionWhyChooseUs1() {
    return (
        <>
            <div className="section-full p-t110 p-b80 sx-why-chooseus-outer sx-bg-light bg-cover" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg-1.jpg")})` }}>
                <div className="container">
                    {/* TITLE START */}
                    <div className="section-head center">
                        <div className="sx-head-s-title">Why Choose Us</div>
                        <div className="sx-head-l-title">
                            <h2 className="sx-title">Our Work Services</h2>
                        </div>
                    </div>
                    {/* TITLE END */}
                    <div className="section-content">
                        <div className="sx-icon-bx-wrap">
                            <div className="row">
                                {/* Block one */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                <NavLink to="/digital-marketing">
                                    <div className="sx-icon-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-icon-bx-icon ">
                                                <span className="sx-text-primary icon-img"><ItodoImage src="images/icons/Digital-Marketing.png" alt="" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="sx-tilte">Digital Marketing</h4>
                                                <p>We Help Grow Your Business with Creative Promotion Ideas</p>
                                            </div>
                                        </div>
                                    </div>
                                </NavLink>
                                </div>
                             
                                {/* Block Two */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                <NavLink to="/web-devlopment" >
                                    <div className="sx-icon-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-icon-bx-icon ">
                                                <span className="sx-text-primary icon-img"><ItodoImage src="images/icons/Software-Developement.png" alt="" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="sx-tilte">Website Development</h4>
                                                <p>Explore Our Services for Custom Software and Personalized Websites</p>
                                            </div>
                                        </div>
                                    </div>
                                </NavLink>
                                </div>
                                {/* Block Three */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                <NavLink to="/content-creation">
                                    <div className="sx-icon-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-icon-bx-icon ">
                                                <span className="sx-text-primary icon-img"><ItodoImage src="images/icons/Content-Creation.png" alt="" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="sx-tilte">Content Creation</h4>
                                                <p>Discover the Features and Benefits of Our Content Creation Service</p>
                                            </div>
                                        </div>
                                    </div>
                                    </NavLink>
                                </div>
                                {/* Block Four */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                <NavLink to="/graphic-design">
                                    <div className="sx-icon-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-icon-bx-icon ">
                                                <span className="sx-text-primary icon-img"><ItodoImage src="images/icons/Graphic-Designer.png" alt="" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="sx-tilte">Graphic Design</h4>
                                                <p>Make Your Social Media Stand Out with Stunning Creative Graphics</p>
                                            </div>
                                        </div>
                                    </div>
                                    </NavLink>
                                </div>
                                {/* Block Five */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                <NavLink to="/video-production">
                                    <div className="sx-icon-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-icon-bx-icon ">
                                                <span className="sx-text-primary icon-img"><ItodoImage src="images/icons/Video-Production.png" alt="" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="sx-tilte">Video Production</h4>
                                                <p>Capture Memorable Moments with Our Expert Video Production Services</p>
                                            </div>
                                        </div>
                                    </div>
                                    </NavLink>
                                </div>
                                {/* Block SIx */}
                                <div className="col-lg-4 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                <NavLink to="/social-media">
                                    <div className="sx-icon-bx-1">
                                        <div className="sx-icon-box-wraper">
                                            <div className="sx-icon-bx-icon ">
                                                <span className="sx-text-primary icon-img"><ItodoImage src="images/icons/Social-Media.png" alt="" /></span>
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="sx-tilte">Edit & Post Production</h4>
                                                <p>Handle Social Media Effectively for Daily Business Updates and Growth.</p>
                                            </div>
                                        </div>
                                    </div>
                                    </NavLink>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionWhyChooseUs1;